module.exports = "/_next/static/images/f55ae3cbdcf1086dc998d411b4265577-woman-holding-device-smiling@0.5x.jpg";